import { DuplicateRowsForm, DuplicateRowsWire } from 'app/area/indicator-factors/list/types-store';
import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { toISODatewithoutTimezone } from 'app/infrastructure/data/date';

export const mapDuplicateRowsToWire = (form: DuplicateRowsForm, searchParams: FilterSearchModel): DuplicateRowsWire => {
  return {
    ...(!!form.location && {
      location: {
        v: form.location.value
      }
    }),
    ...(!!form.unit && {
      unit: {
        v: form.unit.value
      }
    }),
    ...(!!form.source && {
      source: {
        v: form.source.value
      }
    }),
    ...(!!form.validFrom && {
      validFrom: toISODatewithoutTimezone(form.validFrom)()
    }),
    ...(!!form.equipment && {
      equipment: {
        v: form.equipment.value
      }
    }),
    ...(!!searchParams && { searchParams })
  };
};
